import { Calendar } from "@/pages/calendar/Calendar.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export const calendarRoutes: RouteConfig[] = [
  {
    path: "/calendar",
    planFeature: ApiFeatureType.core_company_calendar,
    isHideSidebar: true,
    element: <Calendar />,
  },
];
